export default __webpack_public_path__ + "static/media/minio_operator_logo.1312b7c9.svg";